import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import { PlaceResponse, SearchPlacesQuery, SearchPlacesQueryHandler } from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class PlaceQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly searchPlacesQueryHandler: SearchPlacesQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchPlacesQueryHandler = new SearchPlacesQueryHandler(queryRepository);
  }

  public searchPlaces(query: SearchPlacesQuery): Promise<PlaceResponse[]> {
    return this.searchPlacesQueryHandler.handle(query);
  }
}
